import { useSite } from '../context/SiteContext';
import { pageMeta, buildBreadcrumbJsonLd } from '../config/seo';
import SeoHead from '../components/SeoHead';
import './About.css';

export default function About() {
  const { siteName, getWhatsAppUrl } = useSite();
  const whatsappHref = getWhatsAppUrl();
  const meta = pageMeta.about;

  return (
    <main className="page about-page">
      <SeoHead
        title={meta.title}
        description={meta.description}
        path={meta.path}
        jsonLd={buildBreadcrumbJsonLd([
          { name: 'Anasayfa', path: '/' },
          { name: 'Hakkımızda', path: '/hakkimizda' },
        ])}
      />
      <header className="page-hero">
        <div className="page-hero__inner">
          <h1 className="page-hero__title">Hakkımızda</h1>
          <p className="page-hero__lead">
            Eskişehir’de özel günlerinizi kağıt ve ambalajla anlatıyoruz. Kaliteli
            baskı, özenli paketleme ve hikâyenize uygun tasarım anlayışıyla
            çalışıyoruz.
          </p>
        </div>
      </header>
      <article className="about-content section">
        <h2>Neden biz?</h2>
        <p>
          {siteName} olarak davetiye modelleri ve davetiye çeşitleri sunuyoruz:
          ekonomik davetiye, sade davetiye ve lüks davetiye seçenekleriyle her
          tarza ve bütçeye uygun çözümler üretiyoruz. Davetiye ve şekerlik
          seçimi, misafirlerinize ilk izlenimi veren dokunuşlardan biridir;
          koleksiyonlarımızı güncel trendlerle harmanlayarak okunabilir, sıcak ve
          şık bir dil oluşturmayı hedefliyoruz.
        </p>
        <h2>Nasıl çalışıyoruz?</h2>
        <p>
          Kategori sayfalarından beğendiğiniz stile yakın örnekleri inceleyebilir,
          ardından metin, renk ve adet bilgilerinizle birlikte sipariş veya teklif
          talebinde bulunabilirsiniz. Eskişehir’de yerel üretim ve hızlı iletişim
          ile süreçleri sade tutuyoruz.
        </p>
        <h2>İletişim</h2>
        {whatsappHref ? (
          <>
            <p>
              Sipariş, fiyat ve tasarım danışmanlığı için WhatsApp hattımızdan
              bize yazabilirsiniz; en kısa sürede dönüş yaparız.
            </p>
            <p className="about-whatsapp-wrap">
              <a
                href={whatsappHref}
                className="about-whatsapp-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp ile iletişime geç
              </a>
            </p>
          </>
        ) : (
          <p>
            WhatsApp numaranızı göstermek için yönetim panelindeki{' '}
            <strong>Ayarlar</strong> sayfasından WhatsApp numarasını kaydedin.
          </p>
        )}
      </article>
    </main>
  );
}
